function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* eslint-disable no-restricted-globals */

/* eslint-disable import/no-mutable-exports */

/* eslint-disable no-nested-ternary */
var nextHandle = 1;
var tasksByHandle = new Map();
var currentlyRunningATask = false;
var registerImmediate;
var setImmediate = function setImmediate(callback) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  tasksByHandle.set(nextHandle, [callback, args]);
  registerImmediate(nextHandle);
  return nextHandle++;
};
var clearImmediate = function clearImmediate(handle) {
  tasksByHandle["delete"](handle);
};
function runIfPresent(handle) {
  if (currentlyRunningATask) {
    setTimeout(runIfPresent, 0, handle);
  } else {
    var task = tasksByHandle.get(handle);
    if (task) {
      currentlyRunningATask = true;
      try {
        task[0].apply(task, _toConsumableArray(task[1]));
      } finally {
        clearImmediate(handle);
        currentlyRunningATask = false;
      }
    }
  }
}
function installMessageChannelImplementation() {
  var channel = new MessageChannel();
  channel.port1.onmessage = function (event) {
    runIfPresent(event.data);
  };
  registerImmediate = function registerImmediate(handle) {
    channel.port2.postMessage(handle);
  };
}
function installPostMessageImplementation() {
  var messagePrefix = "setImmediate$".concat(Math.random(), "$");
  window.addEventListener('message', function (event) {
    if (typeof event.data === 'string' && event.data.startsWith(messagePrefix)) {
      runIfPresent(+event.data.slice(messagePrefix.length));
    }
  });
  registerImmediate = function registerImmediate(handle) {
    window.postMessage(messagePrefix + handle, '*');
  };
}
var context = typeof self === 'undefined' ? typeof global === 'undefined' ? this : global : self; // @ts-ignore

if (context.setImmediate) {
  setImmediate = context.setImmediate;
  clearImmediate = context.clearImmediate; // @ts-ignore
} else if (!context.importScripts) {
  installPostMessageImplementation();
} else {
  installMessageChannelImplementation();
}
export { setImmediate, clearImmediate };